<app-alert></app-alert>
<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
        <a [routerLink]="['/']">Home</a>
    </li>
    <li>
        <a [routerLink]="['/director']">Director</a>
    </li>
    <li>{{FirstName}} {{LastName}}</li>
</ul>
<section class="card">
    <div class="card-header">
        <div class="text-center">
            <span class="cat__core__title">
                <strong>Register of Directors and their Shareholding</strong>
                <h5>
                    <strong>[Pursuant to section 170 of the Companies Act, 2013 and rule 17 of the Companies (Appointment & Qualification
                        of Directors Rules 2014)</strong>
                </h5>
            </span>
            <span class="btnBackContainer">
                <a routerLink="/director">
                    <button class="btn btn-sm btn-default pull-right btn-back" type="button">
                        <i class=" fa fa-chevron-circle-left"></i>Back
                    </button>
                </a>
            </span>
            <div class="clearfix"></div>
        </div>
    </div>
    <div class="card-header sub-header-section">
        <div class="text-left">
            <span class="cat__core__title">
                <h5>
                    <strong>Name of the company:</strong>
                    <small>{{CompanyName}}</small>
                </h5>
            </span>
            <span class="cat__core__title">
                <h5>
                    <strong>CIN:</strong>
                    <small>{{CIN}}</small>
                </h5>
            </span>
            <span class="cat__core__title">
                <h5>
                    <strong>Registered office address:</strong>
                    <small>{{registerOfficeAddress}}</small>
                </h5>
            </span>
        </div>
    </div>

    <div class="card-block datatable-card-block">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Director Identification Number:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{DinNumber}}</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Nationality (including the nationality of origin, if different):</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{nationality}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Present name and surname in full:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{FirstName}} {{MiddleName}} {{LastName}}</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Occupation</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{Occupation}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Any former name or surname in full:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{FirstName}} {{MiddleName}} {{LastName}}</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Date of the board resolution in which the appointment was made:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{BoardResolutionDate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Father's Name:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{FatherFirstName}} {{FatherMiddleName}} {{FatherLastName}}</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Mother's Name:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{MotherFirstName}} {{MotherMiddleName}} {{MotherLastName}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Date of appointment in the company:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{AppointmentDate}}</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Date of re-appointment in the company:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{ReAppointmentDate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Date of cessation of office:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{CessationDate}}</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Reason For cessation:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{CessationReason}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Spouse's Name (If married):</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{SpouseFirstName}} {{SpouseMiddleName}} {{SpouseLastName}}</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Date of birth:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{BirthDate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Residential address:</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Present:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{present}}</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Permanent:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{Permanent}}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-header borderTop sub-header-section">
        <span class="cat__core__title">
            <strong>Office of director or KMP held or relinquished in any other body corporate:</strong>
        </span>
    </div>
    <div class="card-block datatable-card-block">
        <div class="row">
            <div class="col-md-12">
                <div class="margin-bottom-50">
                    <div [hidden]="hidedirectorshipauthtable" class="table-responsive">
                        <table datatable [dtOptions]="dtOptionsOfUnauthorizeDirectorships" [dtTrigger]="dtTriggerUnAuthorizeDirectorship" class="table table-hover compact cell-border nowrap stripe" id="authorizedirectorshiptable"
                            style="cursor: pointer;">
                            <thead>
                                <tr>
                                    <th>
                                        <div class="md-checkbox">
                                            <input id="chkAuthorizedirectorshipTableSelectAll" type="checkbox" [(ngModel)]="selectedAll" (change)="selectAll();" />
                                            <label for="chkAuthorizedirectorshipTableSelectAll">&nbsp;</label>
                                        </div>
                                    </th>
                                    <th>Name of Company in which office held</th>
                                    <th>Type of Company</th>
                                    <th>Date of Appointment</th>
                                    <th>Designation held</th>
                                    <th>Date of Cessation/relinquishment</th>
                                    <th>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let unauthorize of unauthorizeDirectorList;let i = index">
                                    <td>
                                        <div class="md-checkbox">
                                            <input id="chkAuthorizedirectorshipTableSelectAll_{{i}}" type="checkbox" [(ngModel)]="unauthorize.SelectedDirectorship" (change)="checkselected($event);"
                                                (change)="checkIfAllSelected();">
                                            <label for="chkAuthorizedirectorshipTableSelectAll_{{i}}">&nbsp;</label>
                                        </div>
                                    </td>
                                    <td>{{unauthorize.OfficeName}}</td>
                                    <td>{{unauthorize.OfficeType}}</td>
                                    <td>{{unauthorize.AppointmentDate | date:"dd-MM-y"}}</td>
                                    <td>{{unauthorize.Designation}}</td>
                                    <td>{{unauthorize.CessationDate | date:"dd-MM-y"}}</td>
                                    <td>
                                        <input type="text" class="form-control" [(ngModel)]="unauthorize.Remarks" id="authdirectorshipremark" style="width: 90%;">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div [hidden]="hidedirectorshiprectify" class="table-responsive">
                        <table datatable [dtOptions]="dtOptionsOfUnrectifiedDirectorship" [dtTrigger]="dtTriggerUnrectifiedDirectorship" class="table table-hover compact cell-border nowrap stripe" id="rectifydirectorshiptable"
                            style="cursor: pointer;">
                            <thead>
                                <tr>
                                    <th>
                                        <div class="md-checkbox">
                                            <input id="chkRectifydirectorshipTableSelectAll" type="checkbox" [(ngModel)]="selectedAllDirectorship" (change)="selectAllDirectorshipToRectify();"
                                            />
                                            <label for="chkRectifydirectorshipTableSelectAll">&nbsp;</label>
                                        </div>
                                    </th>
                                    <th>Name of Company in which office held</th>
                                    <th>Type of Company</th>
                                    <th>Date of Appointment</th>
                                    <th>Designation held</th>
                                    <th>Date of Cessation/relinquishment</th>
                                    <th>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let unrectify of unRectifiedDirectorList;let i = index">
                                    <td>
                                        <div class="md-checkbox">
                                            <input id="chkRectifydirectorshipTableSelectAll_{{i}}" type="checkbox" [(ngModel)]="unrectify.SelectedDirectorship" (change)="checkrectifyselected($event);"
                                                (change)="checkIfAllDirectorshipSelected();">
                                            <label for="chkRectifydirectorshipTableSelectAll_{{i}}">&nbsp;</label>
                                        </div>
                                    </td>
                                    <td>{{unrectify.OfficeName}}</td>
                                    <td>{{unrectify.OfficeType}}</td>
                                    <td>{{unrectify.AppointmentDate | date:"dd-MM-y"}}</td>
                                    <td>{{unrectify.Designation}}</td>
                                    <td>{{unrectify.CessationDate | date:"dd-MM-y"}}</td>
                                    <td>
                                        <input type="text" class="form-control" [(ngModel)]="unrectify.Remarks"  id="rectifydirectorshipremark" style="width: 90%;">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div id="alertTitle" class="modal-header" style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                        Title!
                    </div>
                    <div class="modal-body">
                        <div id="alertMessage">
                            Message..
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-header borderTop sub-header-section">
        <span class="cat__core__title">
            <strong>Details of securities held in the Company, its holding company, subsidiaries, subsidiaries of the companys holding
                company and associate companies:</strong>
        </span>
    </div>
    <div class="card-block datatable-card-block">
        <div class="row">
            <div class="col-md-12">
                <div class="margin-bottom-50">
                    <div class="table-responsive" [hidden]="hidesubdirectorauthtable">
                        <table datatable [dtOptions]="dtOptionsOfUnauthorizSubDirector" [dtTrigger]="dtTriggerUnauthorizedSubDirector" class="table table-hover compact cell-border nowrap stripe" id="authorizeSubdirectortable"
                            style="cursor: pointer;">
                            <thead>
                                <tr>
                                    <th>
                                        <div class="md-checkbox">
                                            <input id="chkAuthorizeSubdirectorTableSelectAll" type="checkbox" [(ngModel)]="allSelected" (change)="allSelect();" />
                                            <label for="chkAuthorizeSubdirectorTableSelectAll">&nbsp;</label>
                                        </div>
                                    </th>
                                    <th>Name of the Company</th>
                                    <th>Number of Securities</th>
                                    <th>Description of Securities</th>
                                    <th>Nominal Value of Securities</th>
                                    <th>Date of Acquisition</th>
                                    <th>Price paid for acquisition of securities</th>
                                    <th>Other consideration paid for acquisition</th>
                                    <th>Date of disposal</th>
                                    <th>Number of shares disposed</th>
                                    <th>Price received on disposal</th>
                                    <th>Other consideration received on disposal</th>
                                    <th>Cumulative balance and number of securities held after each transaction</th>
                                    <th>Mode of acquisition of securities</th>
                                    <th>Mode of holding physical or dematerialized form</th>
                                    <th>Securities have been pledged or any encumbrance has been created</th>
                                    <th>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let unauthorize of unauthorizeSubdirectorList;let i = index">
                                    <td>
                                        <div class="md-checkbox">
                                            <input id="chkAuthorizeSubdirectorTableSelectAll_{{i}}" type="checkbox" [(ngModel)]="unauthorize.SelectedSubdirector" (change)="checkselected($event);"
                                                (change)="checksubIfAllSelected();">
                                            <label for="chkAuthorizeSubdirectorTableSelectAll_{{i}}">&nbsp;</label>
                                        </div>
                                    </td>
                                    <td>{{unauthorize.CompanyName}}</td>
                                    <td>{{unauthorize.NumberOfSecurities}}</td>
                                    <td>{{unauthorize.SecurityDescription}}</td>
                                    <td>{{unauthorize.SecurityNominalValue}}</td>
                                    <td>{{unauthorize.AcquisitionDate | date:"dd-MM-y"}}</td>
                                    <td>{{unauthorize.AcquisitionPaidPrize}}</td>
                                    <td>{{unauthorize.AcquisitionOtherPrize}}</td>
                                    <td>{{unauthorize.DisposalDate| date:"dd-MM-y"}}</td>
                                    <td>{{unauthorize.NumberOfSharesDisposed}}</td>
                                    <td>{{unauthorize.DisposalPrize}}</td>
                                    <td>{{unauthorize.DisposalReceivedPrize}}</td>
                                    <td>{{unauthorize.CumulativePrize}}</td>
                                    <td>{{unauthorize.AcquisitionSecuritiesMode}}</td>
                                    <td>{{unauthorize.HoldingMode}}</td>
                                    <td>{{unauthorize.PledgedSecurities}}</td>
                                    <td>
                                        <input type="text" class="form-control" [(ngModel)]="unauthorize.Remarks" id="authorizesubdirectorremark" style="width: 85%;">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="table-responsive" [hidden]="hidesubdirectorrectify">
                        <table datatable [dtOptions]="dtOptionsOfUnrectifiedSubdirector" [dtTrigger]="dtTriggerUnRectifiedSubDirector" class="table table-hover compact cell-border nowrap stripe" id="rectifySubdirectortable"
                            style="cursor: pointer;">
                            <thead>
                                <tr>
                                    <th>
                                        <div class="md-checkbox">
                                            <input id="chkRectifySubdirectorTableSelectAll" type="checkbox" [(ngModel)]="allsubdirectorselected" (change)="allSubdirectorSelect();"
                                            />
                                            <label for="chkRectifySubdirectorTableSelectAll">&nbsp;</label>
                                        </div>
                                    </th>
                                    <th>Name of the Company</th>
                                    <th>Number of Securities</th>
                                    <th>Description of Securities</th>
                                    <th>Nominal Value of Securities</th>
                                    <th>Date of Acquisition</th>
                                    <th>Price paid for acquisition of securities</th>
                                    <th>Other consideration paid for acquisition</th>
                                    <th>Date of disposal</th>
                                    <th>Number of shares disposed</th>
                                    <th>Price received on disposal</th>
                                    <th>Other consideration received on disposal</th>
                                    <th>Cumulative balance and number of securities held after each transaction</th>
                                    <th>Mode of acquisition of securities</th>
                                    <th>Mode of holding physical or dematerialized form</th>
                                    <th>Securities have been pledged or any encumbrance has been created</th>
                                    <th>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let unrectify of unRectifiedSubdirectorList;let i = index">
                                    <td>
                                        <div class="md-checkbox">
                                            <input id="chkRectifySubdirectorTableSelectAll_{{i}}" type="checkbox" [(ngModel)]="unrectify.SelectedSubdirector" (change)="checkrectifyselected($event);"
                                                (change)="checksubrectifyIfAllSelected();">
                                            <label for="chkRectifySubdirectorTableSelectAll_{{i}}">&nbsp;</label>
                                        </div>
                                    </td>
                                    <td>{{unrectify.CompanyName}}</td>
                                    <td>{{unrectify.NumberOfSecurities}}</td>
                                    <td>{{unrectify.SecurityDescription}}</td>
                                    <td>{{unrectify.SecurityNominalValue}}</td>
                                    <td>{{unrectify.AcquisitionDate | date:"dd-MM-y"}}</td>
                                    <td>{{unrectify.AcquisitionPaidPrize}}</td>
                                    <td>{{unrectify.AcquisitionOtherPrize}}</td>
                                    <td>{{unrectify.DisposalDate| date:"dd-MM-y"}}</td>
                                    <td>{{unrectify.NumberOfSharesDisposed}}</td>
                                    <td>{{unrectify.DisposalPrize}}</td>
                                    <td>{{unrectify.DisposalReceivedPrize}}</td>
                                    <td>{{unrectify.CumulativePrize}}</td>
                                    <td>{{unrectify.AcquisitionSecuritiesMode}}</td>
                                    <td>{{unrectify.HoldingMode}}</td>
                                    <td>{{unrectify.PledgedSecurities}}</td>
                                    <td>
                                        <input type="text" class="form-control"  [(ngModel)]="unrectify.Remarks" id="rectifysubdirectorremark" style="width: 85%;">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div id="alertTitle" class="modal-header" style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                        Title!
                    </div>
                    <div class="modal-body">
                        <div id="alertMessage">
                            Message..
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="confirmation" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="myModalLabelForDelete">
                            <i class="fa fa-question-circle-o mr-2"></i>Confirmation of Password</h5>
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    Enter Password
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <input type="password" [(ngModel)]="password" [ngModelOptions]="{standalone: true}" required="required" class="form-control">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal" (click)="checkPassword()">
                            <i class="fa fa-check"></i>Confirm
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div id="alertTitle" class="modal-header" style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                        Title!
                    </div>
                    <div class="modal-body">
                        <div id="alertMessage">
                            Message..
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="col-md-2" [hidden]="hideauthorizebutton">
            <button id="btnauthorize" style="float: right" type="button" (click)="Confirmation()" [disabled]="!Isselected" class="btn btn-sm btn-primary">
                <i class="fa fa-lock"></i>&nbsp;Authorize
            </button>
        </div>
        <div class="col-md-2" [hidden]="hiderectifybutton">
            <button id="btnrectify" style="float: right" type="button" (click)="Confirmation()" [disabled]="!checkIsslected" class="btn btn-sm btn-primary">
                <i class="fa fa-unlock"></i>&nbsp;Rectify
            </button>
        </div>
    </div>
</section>